interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'header';
  showText?: boolean;
  withSlogan?: boolean;
  className?: string;
}

export function NoCodeoLogo({ size = 'md', showText = false, withSlogan = false, className = '' }: LogoProps) {
  const sizeClasses = {
    sm: 'h-8 w-auto max-w-24',
    md: 'h-10 w-auto max-w-28',
    lg: 'h-12 w-auto max-w-32',
    xl: 'h-16 w-auto max-w-40',
    header: 'h-10 w-auto max-w-36'
  };
  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
    header: 'text-base'
  };

  return (
    <div className={`flex items-center justify-center w-full gap-3 py-2 hover-scale animate-fade-in ${className}`}>
      {/* Logo Image - Cropped to remove white borders */}
      <div className={`${sizeClasses[size]} mx-auto overflow-hidden flex items-center justify-center bg-transparent scale-[1] origin-center`}>
        <img 
          src="/lovable-uploads/967d7e80-8830-41dd-9587-37244ab301a1.png"
          alt="NoCodeo" 
          className="w-full h-full object-contain block select-none pointer-events-none"
          loading="eager"
          decoding="async"
        />
      </div>
      
    </div>
  );
}